import '../../css/HomeBox.css';
import HelpImage from '../../img/help.svg';
import ReportImage from '../../img/report.svg';
import KoFiImage from '../../img/kofi.svg';

const HomeBox = ({ type, children, onClick }) => 
	<div
    className="HomeBox" onClick={onClick}>
    <img alt={type} src={
      type === "help"
        ? HelpImage
      : type === "report"
        ? ReportImage
      : type === "donate"
        ? KoFiImage
      : null
      }
    ></img>
      <p>{children}</p>
  </div>
	

export default HomeBox;